import React, { FC } from 'react'
import CdekPersonalDataAgreementCheckbox from './CdekPersonalDataAgreementCheckbox'
import CdekMailingAgreementCheckbox from './CdekMailingAgreementCheckbox'
import { FocusError } from '../lib/FocusError'

const CdekRulesAgreement: FC = () => (
  <div>
    <CdekPersonalDataAgreementCheckbox />
    <CdekMailingAgreementCheckbox />
    <FocusError />
  </div>
)

export default CdekRulesAgreement
